import { LinkProps } from '@cardboard-ui/react';
import React from 'react';
import { Button, ButtonProps, Link } from '@cardboard-ui/react';
import { t } from '@lingui/macro';
import { NavigateBackIcon } from '../icons';

const buttonStyles = {
  size: 'sm',
  padding: 0,
  fontSize: '18px',
  backgroundColor: 'transparent',
};

interface TopBarActionsProps {
  ariaLabel?: string;
  isLoading?: boolean;
  isDisabled?: boolean;
  children?: React.ReactNode;
}

type TopBarLink = TopBarActionsProps & LinkProps;

export const TopBarLink = ({
  ariaLabel,
  isLoading,
  isDisabled,
  children,
  ...linkProps
}: TopBarLink) => {
  return (
    <Link aria-label={ariaLabel} {...linkProps}>
      <Button {...buttonStyles} isLoading={isLoading} isDisabled={isDisabled}>
        {children}
      </Button>
    </Link>
  );
};

interface TopBarNavigateBackLinkProps {
  withoutText?: boolean;
}

export const TopBarNavigateBackLink = ({
  withoutText,
  ...linkProps
}: TopBarNavigateBackLinkProps & TopBarLink) => {
  return (
    <TopBarLink ariaLabel={t`Navigate back`} {...linkProps}>
      <NavigateBackIcon /> {!withoutText && t`Back`}
    </TopBarLink>
  );
};

type TopBarButtonProps = TopBarActionsProps & ButtonProps;

export const TopBarButton = ({
  ariaLabel,
  onClick,
  isLoading,
  isDisabled,
  children,
  ...otherProps
}: TopBarButtonProps) => {
  return (
    <Button
      aria-label={ariaLabel}
      onClick={onClick}
      {...buttonStyles}
      isLoading={isLoading}
      isDisabled={isDisabled}
      {...otherProps}
    >
      {children}
    </Button>
  );
};
